module.exports = __webpack_public_path__ + "img/logo2.d47e93e3.svg";